import type React from 'react';
import PortfolioItemContext from '../../portfolio-item/PortfolioItemContext';
import { useContext } from 'react';
import ChallengeContext from '../../Challenge/ChallengeView/ChallengeContext';
import TaskContext from './TaskContext';
import { type DraftFunction } from 'use-immer';
import { type TaskSummary } from '@/lib/types';

type TaskPortfolioItemContextProviderProps = {
  children: React.ReactNode;
};

const TaskPortfolioItemContextProvider = ({
  children,
}: TaskPortfolioItemContextProviderProps) => {
  const [, setChallenge] = useContext(ChallengeContext);
  const [task, setTask] = useContext(TaskContext);

  const setTaskSummary = (
    stateUpdateFunction: DraftFunction<TaskSummary>,
  ): void => {
    setChallenge(challenge => {
      stateUpdateFunction(challenge.tasks[task.id]);
    });
  };

  const taskApiEndpoint = `challenge-portfolio/tasks/${task.id}`;

  return (
    <PortfolioItemContext.Provider
      value={{
        portfolioItem: task,
        setPortfolioItem: setTask,
        setPortfolioItemSummary: setTaskSummary,
        portfolioItemApiEndpoint: taskApiEndpoint,
      }}
    >
      {children}
    </PortfolioItemContext.Provider>
  );
};

export default TaskPortfolioItemContextProvider;
